// extracted by mini-css-extract-plugin
module.exports = {"slotContainer":"SlotSelector_slotContainer__2vCuT","flexibleInput":"SlotSelector_flexibleInput__JRIBr","flexibleText":"SlotSelector_flexibleText__3IEvm"};